import * as EventTrackingActions from './ducks/actions';
import EventTracking from './event-tracking';

export {
  EventTracking,
  EventTrackingActions,
};
